import CategorySearchInput from 'components/search/search-input/category-search-input.component';
import SearchInput from 'components/search/search-input/search-input.component';
import { useSearchParamsContext } from 'components/search/search.hooks';
import { useTranslation } from 'react-i18next';

type SearchToolbarInputPropsType = {
  searchInputLabel?: string;
};

const SearchToolbarInput = ({
  searchInputLabel,
}: SearchToolbarInputPropsType) => {
  const { t } = useTranslation();
  const { categories, queryParam } = useSearchParamsContext();

  if (Object.keys(categories).length > 0) {
    return (
      <CategorySearchInput
        aria-label={t('SearchDataGrid.searchToolbar.searchInput.label')}
      />
    );
  }

  return (
    <SearchInput
      placeholder={
        searchInputLabel ?? t('SearchDataGrid.searchToolbar.searchInput.label')
      }
      searchParam={queryParam.paramName}
      aria-label={t('SearchDataGrid.searchToolbar.searchInput.label')}
    />
  );
};

export default SearchToolbarInput;
